import React from 'react';
import Banner from '@components/Banner/banner';
import Footer from '@components/Footer/Footer';
import {
  ContentWrapper,
  SectionContainer,
  SectionWrapper,
  TextBox1,
  StyledHr,
} from './PrivacyPolicy.style';
import { useTranslation, Trans } from 'react-i18next';

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation('privacy');
  const isPortuguese = i18n.language === 'pt';
  return (
    <>
      <Banner title={t('header')} />
      <SectionContainer>
        <SectionWrapper>
          <h1>{t('sectionOne.title')}</h1>
          <StyledHr />
        </SectionWrapper>

        <ContentWrapper>
          <TextBox1>
            <h2>{t('sectionOne.textBox1.h2')}</h2>
            <p>{t('sectionOne.textBox1.spanBefore')}</p>
          </TextBox1>
        </ContentWrapper>
        <SectionWrapper>
          <h1>{t('sectionTwo.title')}</h1>
          <StyledHr />
        </SectionWrapper>

        <ContentWrapper>
          <TextBox1>
            <h2></h2>
            <p>{t('sectionTwo.textBox1.spanBefore')}</p>
          </TextBox1>
        </ContentWrapper>
        <SectionWrapper>
          <h1>{t('sectionThree.title')}</h1>
          <StyledHr />
        </SectionWrapper>

        <ContentWrapper>
          <TextBox1>
            <h2>{t('sectionThree.h2')}</h2>
            <ul>
              <li>{t('sectionThree.text1')}</li>
              <li>{t('sectionThree.text2')}</li>
              <li>{t('sectionThree.text3')}</li>
              <li>{t('sectionThree.text4')}</li>
              <li>{t('sectionThree.text5')}</li>
            </ul>
            <h2>{t('sectionThree.h2-2')}</h2>
            <ul>
              <li>{t('sectionThree.text6')}</li>
              <li>{t('sectionThree.text7')}</li>
              <li>{t('sectionThree.text8')}</li>
            </ul>
          </TextBox1>
        </ContentWrapper>
        <SectionWrapper>
          <h1>{t('sectionFour.title')}</h1>
          <StyledHr />
        </SectionWrapper>

        <ContentWrapper>
          <TextBox1>
            <h2>{t('sectionFour.h2')}</h2>
            <ul>
              <li>{t('sectionFour.text1')}</li>
              <li>{t('sectionFour.text2')}</li>
              <li>{t('sectionFour.text3')}</li>
              <li>{t('sectionFour.text4')}</li>
              <li>{t('sectionFour.text5')}</li>
            </ul>
          </TextBox1>
        </ContentWrapper>
        <SectionWrapper>
          <h1>{t('sectionFive.title')}</h1>
          <StyledHr />
        </SectionWrapper>

        <ContentWrapper>
          <TextBox1>
            <p>{t('sectionFive.h2')}</p>
            <ul>
              <li>{t('sectionFive.text1')}</li>
              <li>{t('sectionFive.text2')}</li>
              <li>{t('sectionFive.text3')}</li>
              <li>{t('sectionFive.text4')}</li>
            </ul>
          </TextBox1>
        </ContentWrapper>
        <SectionWrapper>
          <h1>{t('sectionSix.title')}</h1>
          <StyledHr />
        </SectionWrapper>

        <ContentWrapper>
          <TextBox1>
            <p>{t('sectionSix.paragraph1')}</p>
            <ul>
              <li>{t('sectionSix.li1')}</li>
              <li>{t('sectionSix.li2')}</li>
            </ul>
            <p>{t('sectionSix.paragraph2')}</p>
          </TextBox1>
        </ContentWrapper>
        <SectionWrapper>
          <h1>{t('sectionSeven.title')}</h1>
          <StyledHr />
        </SectionWrapper>

        <ContentWrapper>
          <TextBox1>
            <p>{t('sectionSeven.h2')}</p>
            <ul>
              <li>{t('sectionSeven.text1')}</li>
              <li>{t('sectionSeven.text2')}</li>
              <li>{t('sectionSeven.text3')}</li>
            </ul>
            <p>{t('sectionSeven.p')}</p>
          </TextBox1>
        </ContentWrapper>
        <SectionWrapper>
          <h1>{t('sectionEight.title')}</h1>
          <StyledHr />
        </SectionWrapper>
        <ContentWrapper>
          <TextBox1>
            <p>{t('sectionEight.h2')}</p>
            <ul>
              <li>{t('sectionEight.text1')}</li>
              <li>{t('sectionEight.text2')}</li>
              <li>{t('sectionEight.text3')}</li>
              <li>{t('sectionEight.text4')}</li>
              <li>{t('sectionEight.text5')}</li>
              <li>{t('sectionEight.text6')}</li>
              <li>
                {t('sectionEight.text7')}
                <span>data@context2.ai</span>
              </li>
            </ul>
          </TextBox1>
        </ContentWrapper>
        <SectionWrapper>
          <h1>{t('sectionNine.title')}</h1>
          <StyledHr />
        </SectionWrapper>
        <ContentWrapper>
          <TextBox1>
            <p>{t('sectionNine.h2')}</p>
            <ul>
              <li>{t('sectionNine.text1')}</li>
              <li>{t('sectionNine.text2')}</li>
              <li>{t('sectionNine.text3')}</li>
            </ul>
          </TextBox1>
        </ContentWrapper>
        <SectionWrapper>
          <h1>{t('sectionTen.title')}</h1>
          <StyledHr />
        </SectionWrapper>
        <ContentWrapper>
          <TextBox1>
            <p>{t('sectionTen.h2')}</p>
          </TextBox1>
        </ContentWrapper>
        <SectionWrapper>
          <h1>{t('sectionEleven.title')}</h1>
          <StyledHr />
        </SectionWrapper>
        <ContentWrapper>
          <TextBox1>
            <p>
              {t('sectionEleven.h2')}
              <span>data@context2.ai</span>
            </p>
            <p>
              <strong>{t('sectionEleven.p2')}</strong>
            </p>
            <p>
              <strong>{t('sectionEleven.p3')}</strong>
            </p>
            <h2>{t('sectionEleven.h3')}</h2>
            <ul>
              <li>{t('sectionEleven.text1')}</li>
              <li>{t('sectionEleven.text2')}</li>
              <li>{t('sectionEleven.text3')}</li>
            </ul>
            <p>
              <strong>{t('sectionEleven.p4')}</strong>
            </p>
            <ul>
              <li>{t('sectionEleven.text4')}</li>
              <li>{t('sectionEleven.text5')}</li>
              <li>{t('sectionEleven.text6')}</li>
              <li>{t('sectionEleven.text7')}</li>
              <li>{t('sectionEleven.text8')}</li>
              <li>{t('sectionEleven.text9')}</li>
              <li>{t('sectionEleven.text10')}</li>
            </ul>
          </TextBox1>
        </ContentWrapper>
      </SectionContainer>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
